import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { IOnboardingReportSummary } from '../../fi-onboarding-report';

@Component({
    selector: 'fi-onboarding-report-summary-card',
    templateUrl: './fi-onboarding-report-summary-card.component.html',
    styleUrls: ['./fi-onboarding-report-summary-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-report-summary-card' },
    standalone: false,
})
export class FiOnboardingReportSummaryCardComponent {
    public reportSummary = input.required<IOnboardingReportSummary>();
    public cardTitle = input<string>();
    public isOnlyCompleted = input<boolean>(false);
}
